// Central API configuration + thin fetch wrapper.
//
// API_URL was previously redefined as a local const in ~25 components
// (`const API_URL = process.env.REACT_APP_API_URL || ""`).
// Import it from here instead. `apiFetch` additionally attaches the auth token
// and parses JSON, so call sites shrink to a single line.

export const API_URL = process.env.REACT_APP_API_URL || "";

/**
 * fetch wrapper that:
 *  - resolves relative paths against API_URL ("/api/foo" -> `${API_URL}/api/foo`)
 *  - attaches `Authorization: Bearer <token>` from localStorage when present
 *  - sets JSON content-type for body'd requests (unless sending FormData)
 *  - throws on non-2xx, parses and returns JSON
 */
export const apiFetch = async (path, options = {}) => {
  const url = path.startsWith("http") ? path : `${API_URL}${path}`;
  const token = localStorage.getItem("token");
  const isFormData =
    typeof FormData !== "undefined" && options.body instanceof FormData;

  const headers = {
    ...(options.body && !isFormData ? { "Content-Type": "application/json" } : {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...options.headers,
  };

  const response = await fetch(url, { ...options, headers });
  if (!response.ok) {
    let message = `Request failed (${response.status})`;
    try {
      const data = await response.json();
      message = data.message || message;
    } catch {
      /* response had no JSON body */
    }
    throw new Error(message);
  }

  if (response.status === 204) return null;
  const text = await response.text();
  return text ? JSON.parse(text) : null;
};
